<div *ngIf="disableEditing"
    style="width: 100%; height: 100%; position: absolute; z-index: 100000; display: flex; justify-content: center; align-items: center;">
    <div class="spinner-border text-primary avatar-sm" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>

<div class="modal-header bg-soft-info p-3">
    <h5 class="modal-title" id="exampleModalLabel">
        <span *ngIf="model.id === undefined">Create</span>
        <span *ngIf="model.id != undefined">Update</span>

    </h5>

    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"
        (click)="close()"></button>
</div>


<div class="card-header mt-3">

    <ul ngbNav #customNav="ngbNav" [(activeId)]="activeTab"
        class="nav nav-tabs-custom card-header-tabs border-bottom-0 center justify-content-center" role="tablist">
        <li [ngbNavItem]="1" class="nav-item">
            <a ngbNavLink class="nav-link text-body " style="text-align: center" data-bs-toggle="tab" role="tab">
                <i class="fas fa-home"></i>
                <div i18n="@@ContactPopUp_tab_ContactDetails ">Details</div>
            </a>
            <ng-template ngbNavContent>
                <div class="gap-2 overflow-hidden" style="padding-right: 0.5rem;">
                    <div class="col-lg-12 row col-auto justify-content-center"
                        style="display: flex; align-items: stretch; margin: auto;">
                        <div class="col-lg-3 mb-2" style="padding-left: 0px;">
                            <div class="card mb-0" >
                                <div class="card-body ">
                                    <div class="mb-3">
                                        <label class="form-label" for="project-title-input">Title</label>
                                        <input type="text" class="form-control" id="project-title-input"
                                            [(ngModel)]="model.title" placeholder="Enter title">
                                    </div>
                                    <div class="mb-3">
                                        <label class="form-label">Description</label>
                                        <input type="text" class="form-control" id="project-title-input"
                                            [(ngModel)]="model.description" placeholder="Enter a description">
                                    </div>
                                    <div class="row" class="mb-3 ">
                                        <div>
                                            <label for="datepicker-deadline-input" class="form-label">Publishing
                                                Date</label>
                                            <input class="form-control flatpickr-input" type="text"
                                                placeholder="Enter date" mwlFlatpickr [disableMobile]="true" [altInput]="true"
                                                [(ngModel)]="model.publishDate" [convertModelValue]="true"
                                                [dateFormat]="'Y-m-d'">
                                        </div>
                                    </div>


                                </div>

                            </div>

                        </div>
                        <div class="col-lg-3 card mb-2">
                            <div class="card-header">
                                <h5 class="card-title mb-0">Thumbnail Image</h5>
                            </div>
                            <div class="card-body">
                                <div class="d-flex justify-content-center mb-2">
                                    <div class="profile-user position-relative p-1" style="height: 8.2rem; width: 8.2rem;">
                                        <div class="avatar-title bg-light rounded-corner">
                                            <img [src]="profileImageURL" class=" rounded-corner object-cover" style="height: 7rem; width: 7rem;">
                                        </div>
                                    </div>
                                </div>
                                <div class="p-0 rounded-circle profile-photo-edit">
                                    <input accept="image/png, image/jpeg" class="form-control" type="file"
                                        (change)="uploadPhotoDirectly(model, $event, enumEntityFileType.ProfilePhoto)"
                                        #fileUpload>
                                </div>

                            </div>

                        </div>

                        <div class="col-lg-3  d-grid">
                            <div class="card mb-2">
                                <div class="card-header">
                                    <h5 class="card-title mb-0">Tags</h5>
                                </div>
                                <div class="p-3">
                                    <div class="d-flex align-items-center form-control "
                                        style="padding: 0%; border-width: 0px; ">
                                        <ng-select style="flex-grow: 1; max-width: 100%; " [multiple]="true"
                                            [selectOnTab]="true" placeholder="Add custom tags" [clearSearchOnAdd]="true"
                                            [(ngModel)]="model.tags" [addTag]="addCustomTag" [typeahead]="searchTerm$">
                                            <ng-template ng-tag-tmp let-item="item" let-clear="clear">
                                                <span class="ng-value-label ">
                                                    <span style="font-size: 80% !important; ">
                                                        Add Tag:
                                                    </span>
                                                    <span>
                                                        "{{searchTerm}}"
                                                    </span>
                                                </span>
                                            </ng-template>
                                            <ng-template ng-label-tmp let-item="item" let-clear="clear">
                                                <div class="d-flex">
                                                    <span class="ng-value-icon left" (click)="clear(item)">×</span>
                                                    <div class="d-flex">
                                                        <span class="ng-value-label text-white">
                                                            {{item}}
                                                        </span>
                                                    </div>
                                                </div>
                                            </ng-template>

                                        </ng-select>
                                    </div>
                                </div>

                            </div>

                            <div class="card mb-2">
                                <div class="card-header">
                                    <h5 class="card-title mb-0">Categories</h5>
                                </div>
                                <div class="p-3">
                                    <div class="d-flex align-items-center form-control "
                                        style="padding: 0%; border-width: 0px; ">

                                        <ng-select style="flex-grow: 1; max-width: 100%; " [multiple]="true"
                                            [items]="categoryOptions" [selectOnTab]="true"
                                            placeholder="Add custom category" [clearSearchOnAdd]="true"
                                            [(ngModel)]="model.categories" [addTag]="addCustomTag"
                                            [typeahead]="searchTerm$">
                                            <ng-template ng-tag-tmp let-item="item" let-clear="clear">
                                                <span class="ng-value-label ">
                                                    <span style="font-size: 80% !important; ">
                                                        Add Category:
                                                    </span>
                                                    <span>
                                                        "{{searchTerm}}"
                                                    </span>
                                                </span>
                                            </ng-template>
                                            <ng-template ng-option-tmp class="border-light" let-item="item"
                                                let-clear="clear">
                                                <span class="ng-value-label"
                                                    [ngClass]="{'text-muted': item.default==true}">
                                                    <span
                                                        *ngIf="(item.dropdownText !== undefined) else elseSelectedText">
                                                        {{item.dropdownText}}
                                                    </span>
                                                    <ng-template #elseSelectedText>
                                                        <span
                                                            *ngIf="(item.selectedText  !== undefined) else elseValueText">
                                                            {{item.selectedText}}
                                                        </span>
                                                    </ng-template>
                                                    <ng-template #elseValueText>
                                                        <span *ngIf="(item.selectedText  !== undefined) else elseItem">
                                                            {{item.value}}
                                                        </span>
                                                    </ng-template>
                                                    <ng-template #elseItem>
                                                        {{item}}
                                                    </ng-template>
                                                </span>
                                            </ng-template>
                                            <ng-template ng-label-tmp let-item="item" let-clear="clear">
                                                <div class="d-flex">
                                                    <span class="ng-value-icon left" (click)="clear(item)">×</span>
                                                    <div class="d-flex">
                                                        <span class="ng-value-label text-white">
                                                            {{item}}
                                                        </span>
                                                    </div>
                                                </div>
                                            </ng-template>

                                        </ng-select>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="col-lg-3 card mb-2">
                            <div class="card-header">

                                <h5 class="card-title mb-0">Status</h5>
                            </div>


                            <div class="p-3">
                                <app-ng-select-layout [placeHolderText]="'Select Status'" [(model)]="model.status"
                                    [items]="blogStatusOptions"></app-ng-select-layout>
                            </div>
                            <div class="p-3 pt-0">
                                <label for="job-title-Input" class="form-label">Is Public </label>
                                <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" [(ngModel)]="model.isPublic" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="card mb-2">
                            <div class="card-header">
                                <h5 class="card-title mb-0">Blog Text</h5>
                            </div>
                            <div class="card-body">
                                <app-rich-text-editor  [textToEdit]="model.blogText" [inputHeight]=400
                                    (textToEditChange)="updateText($event)">
                                </app-rich-text-editor>
                            </div>
                        </div>

                    </div>

                </div>
            </ng-template>

        </li>

        <li [ngbNavItem]="2" class="nav-item">
            <a ngbNavLink class="nav-link text-body" data-bs-toggle="tab" role="tab">
                <i class="far fa-user"></i>
                <span i18n="@@">Attachments</span>
            </a>

            <ng-template ngbNavContent>
                <span *ngIf="newModel == false">
                    <app-file-management [entityId]="model.id" [entityTypeId]="entityTypeId"
                        [entityName]="model.title"></app-file-management>
                </span>
                <span *ngIf="newModel == true">
                    <app-file-management [filesIdsToAdd]="model.fileUpload.fileIdsToAdd"
                        (filesIdsToAddChanged)="onNewModalEntityFileIdsAdded(model,$event)" [entityName]="model.title"
                        [entityFiles]="model.fileUpload.entityFiles"></app-file-management>
                </span>
            </ng-template>

        </li>


    </ul>

    <div class="card-body p-4  ">

        <div [ngbNavOutlet]="customNav" class="mb-3"></div>

        <div class="hstack justify-content-end gap-2" style="margin-top: 0.5rem;">
            <button *ngIf="newModel === false && model.isPublic === false && hasBlogDelete" [disabled]="disableEditing"
                type="button" class="btn btn-danger" id="add-btn" (click)="onDelete()" i18n="">Delete</button>
            <button *ngIf="newModel === false" [disabled]="disableEditing" type="button" class="btn btn-soft-primary"
                id="add-btn" (click)="onView()">
                <span>View</span>
            </button>

            <button *ngIf="newModel && hasBlogCreate" [disabled]="disableEditing" type="button" class="btn btn-success"
                id="add-btn" (click)="onCreate()" i18n="">Create</button>
            <button *ngIf="newModel === false && hasBlogUpdate" [disabled]="disableEditing" type="button"
                class="btn btn-success" id="add-btn" (click)="onUpdate()" i18n="">Update</button>
        </div>

    </div>
</div>